import { bool, number, object, string } from "prop-types";
import { useRef, useState } from "react";

import styled from "styled-components/macro";

import { useUserData } from "Flocknote/apiHooks";

import { useOpenSacramentModal } from "Boards/Cells/Dynamic/SacramentFields/useOpenSacramentModal";

import ExtendedFieldPopover from "./ExtendedFieldPopover";
import { cellContainerStyles, editableCellStyles } from "./cellContainerStyles";

DateCell.propTypes = {
  columnID: number,
  entityID: number,
  value: string,
  rawValue: string,
  extendedFieldData: object,
  canEdit: bool,
  fieldTypeInstanceStructureGroupingID: number,
};

export default function DateCell({
  columnID,
  entityID,
  value = "",
  rawValue,
  extendedFieldData,
  // saveCellValue,
  canEdit,
  fieldTypeInstanceStructureGroupingID,
}) {
  const [showPopover, setShowPopover] = useState(false);
  const buttonRef = useRef();
  const [{ canEditSacraments }] = useUserData();

  let initialValue;
  if (typeof rawValue !== "undefined") {
    try {
      initialValue = JSON.parse(rawValue);
      // if (Array.isArray(initialValue) && !initialValue.length)
      //   initialValue = { month: null, day: null };
    } catch (e) {
      console.error(e);
    }
  }

  const isSacramentField =
    extendedFieldData?.fieldTypeInstanceStructureGroupingID === 1;

  const sacramentIsEditable =
    isSacramentField &&
    canEditSacraments &&
    canEdit &&
    (initialValue?.isEditable || true);

  const nonSacramentIsEditable =
    (canEdit && initialValue?.isEditable && !isSacramentField) || true;

  const canEditField = isSacramentField
    ? sacramentIsEditable
    : nonSacramentIsEditable;

  const { openSacramentModal } = useOpenSacramentModal({
    targetUserID: entityID,
    defaultFieldTypeInstanceMapping:
      extendedFieldData?.defaultFieldTypeInstanceMapping,
    networkFieldID: extendedFieldData?.networkAvailableFieldID,
  });

  const handleCellClick = () => {
    if (!canEditField) return;

    if (isSacramentField && canEditSacraments) {
      openSacramentModal();
      return;
    }

    setShowPopover((prev) => !prev);
  };

  const handleKeyPress = (e) => {
    if (e.key !== "Enter") return;

    e.preventDefault();
    handleCellClick();
  };

  const extendedFieldPopoverId = `${
    extendedFieldData?.title ?? "date"
  }-${entityID}-${columnID}`
    .replaceAll(" ", "-")
    .toLowerCase();

  return (
    <>
      <ExtendedFieldPopover
        buttonRef={buttonRef}
        showPopover={showPopover}
        setShowPopover={setShowPopover}
        field={extendedFieldData}
        initialValue={initialValue}
        cellData={{ columnID, entityID }}
        id={extendedFieldPopoverId}
      />
      <Container
        ref={buttonRef}
        onClick={handleCellClick}
        onKeyPress={handleKeyPress}
        $canEdit={canEditField}
        $canEditSacraments={canEditSacraments}
        role="combobox"
        tabIndex={0}
        aria-expanded={showPopover}
        aria-haspopup="dialog"
        aria-controls={extendedFieldPopoverId}
      >
        {value === "Invalid Date" ? "" : value}
      </Container>
    </>
  );
}

const Container = styled.div`
  ${cellContainerStyles};
  ${(p) => (p.$canEdit ? editableCellStyles : null)}
  cursor: ${(p) =>
    p.$canEdit || p.$canEditSacraments ? "pointer" : "default"};
`;
